// JOBE-0166.1: useEvalSuites — thin hook that reads the promptops.suites
// slice from the Zustand store and triggers loadEvalSuites on mount.

import { useEffect } from 'react';
import { useStore } from '../lib/store.js';

export function useEvalSuites() {
  const suites = useStore((s) => s.promptops?.suites ?? []);
  const loadEvalSuites = useStore((s) => s.loadEvalSuites);
  useEffect(() => {
    loadEvalSuites();
  }, [loadEvalSuites]);
  return { suites };
}
